import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {Injectable} from "@angular/core";
import {AuthService} from "./auth.service";
import {NotFoundPage} from "../pages/not-found/not-found-page.component";
import {tap} from "rxjs/operators";
import {LoadingService} from "./loading.service";
import {AlertController, ToastController} from "@ionic/angular";

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private readonly router: Router,
              private readonly auth: AuthService,
              private readonly alertController: AlertController,
              private readonly toastController: ToastController) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.isAuthenticated) {
      req = req.clone(
        {
          setHeaders: {
            'Authorization': `Bearer ${this.auth.accessToken}`
          }
        }
      );
    }
    return next.handle(req).pipe(
      tap(
        async (event) => {
          if (event instanceof HttpResponse) {
            if (event.body?.messages?.length > 0) {
              const toast = await this.toastController.create({
                message: event.body?.messages[0],
                duration: 3000
              });

              await toast.present();
            }
          }
        },
        async (err: HttpErrorResponse) => {
          console.error('[Interceptor error]: ', err);
          if (err instanceof HttpErrorResponse) {
            if (err.status == 401) {
              const alert = await this.alertController.create({
                header: 'Необходимо Авторизоваться',
                buttons: ['OK'],
              });
              await alert.present();
              this.auth.logout();
            }
            else if (err.status === 404)
            {
              const alert = await this.alertController.create({
                header: 'Страница не найдена',
                buttons: ['OK'],
              });
              await alert.present();
            }
            else if (err.status === 500)
            {
              const alert = await this.alertController.create({
                header: 'Ошибка',
                message: 'Сервис временно недоступен',
                buttons: ['OK'],
              });
              await alert.present();
            }
          }
        }
      )
    );
  }
}
